import * as React from 'react'
import { useState } from 'react'
import MediaModal from '../sharedComponents/MediaModal'

export interface IVideoPlayer {
  VimeoUrl: string
  ImageUrl: string
}

function VideoPlayer({ content }: { content: IVideoPlayer }) {
  const [open, setOpen] = useState(false)

  return (
    <div>
      <div className="relative">
        <img
          src={content.ImageUrl}
          alt="Gallery"
          className=" w-full object-cover"
          onClick={() => setOpen(true)}
        />
        <button
          onClick={() => {
            setOpen(true)
          }}
          className="btn btn-play absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
        ></button>
      </div>
      {open && (
        <MediaModal setOpen={setOpen} fullScreen={true}>
          <iframe
            className="aspect-video my-4 md:my-6 xl:my-10"
            src={content.VimeoUrl}
            width="100%"
          ></iframe>
        </MediaModal>
      )}
    </div>
  )
}

export default VideoPlayer
